(function() {
  document.addEventListener("DOMContentLoaded", function() {
    // Vérification et initialisation du système PubSub
    if (!(typeof window.PUB_SUB_EVENTS !== "undefined" && 
          typeof window.publish === "function" && 
          typeof window.subscribe === "function")) {
      console.info("Système PubSub non détecté - implémentation d'une version compatible");
      
      window.PUB_SUB_EVENTS = {
        cartUpdate: "cart-update",
        quantityUpdate: "quantity-update",
        variantChange: "variant-change",
        cartError: "cart-error"
      };

      let subscribers = {};
      
      window.subscribe = function(eventName, callback) {
        if (subscribers[eventName] === undefined) {
          subscribers[eventName] = [];
        }
        subscribers[eventName] = [...subscribers[eventName], callback];
        
        return function() {
          subscribers[eventName] = subscribers[eventName].filter(cb => cb !== callback);
        };
      };
      
      window.publish = function(eventName, data) {
        if (subscribers[eventName]) {
          subscribers[eventName].forEach(callback => {
            callback(data);
          });
        }
      };
    }

    // Initialisation
    initIntegration();

    // Observer pour les changements DOM
    const observer = new MutationObserver(function(mutations) {
      for (let mutation of mutations) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          const hasBQB = document.querySelector(".bqb-ui");
          const hasSealSubs = document.querySelector(".sealsubs-target-element");
          
          if (hasBQB || hasSealSubs) {
            initIntegration();
          }
        }
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    function initIntegration() {
      const bqbUI = document.querySelector(".bqb-ui");
      const sealSubsElements = document.querySelectorAll(".sealsubs-target-element");

      if (bqbUI && sealSubsElements.length > 0) {
        // CORRECTION CRITIQUE : Cacher Seal Subs quand BQB est actif
        hideSealSubsWhenBQBActive();
        initBQBFunctions();
        listenToSealSubsEvents();
        subscribeToQuantityEvents();
      } else if (bqbUI) {
        initBQBFunctions();
        subscribeToQuantityEvents();
      }
    }

    // CORRECTION : Nouvelle fonction pour cacher Seal Subs
    function hideSealSubsWhenBQBActive() {
      const style = document.createElement("style");
      style.textContent = `
        .sealsubs-container { display: none !important; }
        .sealsubs-target-element { display: none !important; }
      `;
      document.head.appendChild(style);
      console.info("BQB: Seal Subscriptions masqué car BQB est actif");
    }

    function initBQBFunctions() {
      // Fonction pour mettre à jour la quantité
      window.bqb_updateQuantity = function(newQuantity) {
        const quantityInput = document.getElementById("Quantity-buy_buttons");
        if (quantityInput) {
          quantityInput.value = newQuantity;
          publish(PUB_SUB_EVENTS.quantityUpdate, {
            quantity: newQuantity,
            source: "bqb"
          });
          console.info(`BQB: Quantité mise à jour à ${newQuantity}`);
        }
      };

      // Fonction pour initialiser les plans de vente
      window.bqb_initSellingPlans = function() {
        document.querySelectorAll('[action*="/cart/add"]').forEach(addToCartForm => {
          if (!addToCartForm.querySelector('[name="selling_plan"]')) {
            var bqb_sellingPlanInput = document.createElement("input");
            bqb_sellingPlanInput.type = "hidden";
            bqb_sellingPlanInput.name = "selling_plan";
            bqb_sellingPlanInput.value = "";
            addToCartForm.appendChild(bqb_sellingPlanInput);
          }
        });
        console.info("BQB: Plans de vente initialisés");
      };

      // Fonction pour mettre à jour le plan de vente
      window.bqb_updateSellingPlan = function(newSellingPlan) {
        document.querySelectorAll('[action*="/cart/add"]').forEach(addToCartForm => {
          let sellingPlanInput = addToCartForm.querySelector('[name="selling_plan"]');
          if (!sellingPlanInput) {
            sellingPlanInput = document.createElement("input");
            sellingPlanInput.type = "hidden";
            sellingPlanInput.name = "selling_plan";
            sellingPlanInput.value = "";
            addToCartForm.appendChild(sellingPlanInput);
          }
          sellingPlanInput.value = newSellingPlan;
          console.info(`BQB: Plan de vente mis à jour à ${newSellingPlan || "achat unique"}`);
        });
      };

      window.bqb_initSellingPlans();
    }

    function subscribeToQuantityEvents() {
      subscribe(PUB_SUB_EVENTS.quantityUpdate, function(data) {
        if (data && data.source !== "bqb") {
          const quantityInput = document.getElementById("Quantity-buy_buttons");
          if (quantityInput && data.quantity) {
            quantityInput.value = data.quantity;
            console.info(`PubSub: Synchronisation de la quantité BQB à ${data.quantity}`);
          }
        }
      });
      console.info("PubSub: Abonnement aux événements de quantité");
    }

    function listenToSealSubsEvents() {
      // Écouter la création du widget Seal Subs
      document.addEventListener("sealsubs:subscription_widget_created", function(e) {
        console.info("Seal Subscriptions: Widget créé");
      });

      // Écouter les mises à jour de prix
      document.addEventListener("sealsubs:price_update", function(e) {
        console.info("Seal Subscriptions: Prix mis à jour", e.detail);
      });

      // Écouter les changements de plan de vente
      document.addEventListener("sealsubs:selling_plan_changed", function(e) {
        const sellingPlanId = e.detail.selling_plan_id;
        console.info(`Seal Subscriptions: Plan de vente changé à ${sellingPlanId || "achat unique"}`);
        
        if (sellingPlanId) {
          // Désélectionner toutes les options BQB
          document.querySelectorAll('.bqb-ui input[type="radio"]').forEach(radio => {
            radio.checked = false;
          });
          console.info("Seal Subscriptions: Options BQB désélectionnées");
        }
      });

      // Écouter les clics sur BQB pour réinitialiser Seal Subs
      document.addEventListener("click", function(e) {
        if (e.target && e.target.matches('.bqb-ui input[type="radio"]')) {
          document.querySelectorAll(".sealsubs-target-element").forEach(element => {
            if (typeof SealSubs !== "undefined" && typeof SealSubs.refresh === "function") {
              const event = new CustomEvent("sealsubs:change_selected_selling_plan_id", {
                detail: { selling_plan_id: "" }
              });
              element.dispatchEvent(event);
              console.info("BQB: SealSubs réinitialisé à achat unique");
            }
          });
        }
      });

      console.info("Événements SealSubs: Écouteurs initialisés");
    }
  });
})();